import { countMessagesSentByHourOfWeek } from '../queries/countMessagesSentByHourOfWeek'

export const messagesSentByHourOfWeekGauge = {
  id: 'messagesSentByHourOfWeekGauge',
  queries: [countMessagesSentByHourOfWeek],
  title: 'Busiest Hours of The Day',
}
